<script lang="ts" generics="TransitionInConfig, TransitionOutConfig">
    import { readTransitions, type TransitionsInOut } from '$lib/utils/transition.js';

    let className = '';
    export { className as class };

    export let transitions: TransitionsInOut<TransitionInConfig, TransitionOutConfig> =
        {};
    const { inFunc, inOptions, outFunc, outOptions } = readTransitions(transitions);
</script>

{#if inFunc != null && outFunc != null}
    <div class={className} in:inFunc={inOptions} out:outFunc={outOptions}>
        <slot />
    </div>
{:else if inFunc != null && outFunc == null}
    <div class={className} in:inFunc={inOptions}>
        <slot />
    </div>
{:else if inFunc == null && outFunc != null}
    <div class={className} out:outFunc={outOptions}>
        <slot />
    </div>
{:else}
    <div class={className}>
        <slot />
    </div>
{/if}
